/* import __COLOCATED_TEMPLATE__ from './example-questions-header-context.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();